import { Buffer } from "buffer";
const IconReplay = (color: string = "#fff") => {
  const icon = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 28.542">
      <defs>
        <clipPath id="clip-path">
          <rect
            width="24"
            height="24"
            transform="translate(0 -0.025)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
          />
        </clipPath>
      </defs>
      <g transform="translate(-483 -886.457)">
        <path
          d="M5.407,0,0,5.259l5.407,5.259"
          transform="translate(490.16 887.387) rotate(-2)"
          fill="none"
          stroke="${color}"
          stroke-width="2"
        />
        <g transform="translate(486.293 894.023)">
          <g transform="translate(-3.293 -2.999)" clip-path="url(#clip-path)">
            <path
              d="M.5,10.73A10.23,10.23,0,1,0,10.73.5H7.249"
              transform="translate(1.411 1.104)"
              fill="none"
              stroke="${color}"
              stroke-miterlimit="10"
              stroke-width="2"
            />
          </g>
        </g>
      </g>
    </svg>
    `;
  const base64 =
    "data:image/svg+xml;base64," + Buffer.from(icon).toString("base64");
  return base64;
};

export default IconReplay;
